jQuery(document).ready(function ($) {
  //################################################################//
  //######*****   Radio and Checkbox
  //######*****   Custom radio and checkboxes
  //################################################################//

  //Add class to selected radios
  $('.c-form .gfield_radio div input[type="radio"]').change(function () {
    if ($(this).prop("checked") == true) {
      $(this)
        .parent()
        .addClass("is-checked")
        .siblings()
        .removeClass("is-checked");
    }
  });
  //Add class to selected Checkboxes
  $('.c-form .gfield_checkbox div input[type="checkbox"]').change(function () {
    if ($(this).is(":checked")) {
      $(this).parent().addClass("is-checked");
    } else {
      $(this).parent().removeClass("is-checked");
    }
  });

  //Remove validation
  $(".c-form .gfield_radio .LV_validation_message").remove();
  $(".c-form .gfield_radio").mousedown(function () {
    $(".c-form .gfield_radio .LV_validation_message").remove();
  });

  $(".c-form .gfield_checkbox .LV_validation_message").remove();
  $(".c-form .gfield_checkbox ").mousedown(function () {
    $(".c-form .gfield_checkbox .LV_validation_message").remove();
  });
});
